export const FETCH_SFDC_ATTRIBUTES_SUCCESS = 'FETCH_SFDC_ATTRIBUTES_SUCCESS'
export const FETCH_SFDC_ATTRIBUTES_ERROR = 'FETCH_SFDC_ATTRIBUTES_ERROR'
export const FETCH_SFDC_TASK_ATTRIBUTES_SUCCESS  = 'FETCH_SFDC_TASK_ATTRIBUTES_SUCCESS'
export const FETCH_SFDC_TASK_ATTRIBUTES_ERROR = 'FETCH_SFDC_TASK_ATTRIBUTES_ERROR'
export const FETCH_SFDC_MAPPINGS_SUCCESS = 'FETCH_SFDC_MAPPINGS_SUCCESS'
export const FETCH_SFDC_MAPPINGS_ERROR = 'FETCH_SFDC_MAPPINGS_ERROR'
export const FETCH_SFDC_METRIC_MAPPINGS_SUCCESS = 'FETCH_SFDC_METRICS_MAPPINGS_SUCCESS'
export const FETCH_SFDC_METRIC_MAPPINGS_ERROR = 'FETCH_SFDC_METRICS_MAPPINGS_ERROR'
export const FETCH_METRICS_LIST_SUCCESS = 'FETCH_SFDC_METRICS_LIST_SUCCESS'
export const FETCH_METRICS_LIST_ERROR = 'FETCH_SFDC_METRICS_LIST_ERROR'

export const PATCH_SFDC_MAPPINGS_ERROR = 'PATCH_SFDC_MAPPINGS_ERROR'
export const PATCH_SFDC_MAPPINGS_SUCCESS = 'PATCH_SFDC_MAPPINGS_SUCCESS'
export const PATCH_SFDC_MAPPINGS_START = 'PATCH_SFDC_MAPPINGS_START'
export const PATCH_SFDC_METRIC_MAPPINGS_ERROR = 'PATCH_SFDC_METRIC_MAPPINGS_FAILED'
export const PATCH_SFDC_METRIC_MAPPINGS_SUCCESS = 'PATCH_SFDC_METRIC_MAPPINGS_SUCCESS'
export const PATCH_SFDC_METRIC_MAPPINGS_START = 'PATCH_SFDC_METRIC_MAPPINGS_START'

export const FETCH_SFDC_USERS_START = 'FETCH_SFDC_USERS_START'
export const FETCH_SFDC_USERS_SUCCESS = 'FETCH_SFDC_USERS_SUCCESS'
export const FETCH_SFDC_USERS_ERROR = 'FETCH_SFDC_USERS_ERROR'

export const FETCH_SFDC_USER_MAPPINGS_SUCCESS = 'FETCH_SFDC_USER_MAPPINGS_SUCCESS'

export const PATCH_SFDC_USER_MAPPINGS_FAILED = 'PATCH_SFDC_USER_MAPPINGS_FAILED'
export const PATCH_SFDC_USER_MAPPINGS_SUCCESS = 'PATCH_SFDC_USER_MAPPINGS_SUCCESS'
export const PATCH_SFDC_USER_MAPPINGS = 'PATCH_SFDC_USER_MAPPINGS'

export const FETCH_SFDC_OBJECT_LIST_SUCCESS = 'FETCH_SFDC_OBJECT_LIST_SUCCESS'
export const FETCH_SFDC_OBJECT_LIST_ERROR = 'FETCH_SFDC_OBJECT_LIST_ERROR'

export const FETCH_SFDC_FIELD_LIST_SUCCESS = 'FETCH_SFDC_FIELD_LIST_SUCCESS'
export const FETCH_SFDC_FIELD_LIST_ERROR = 'FETCH_SFDC_FIELD_LIST_ERROR'
export const SFDC_ACCOUNT_FIELDS = 'Account'
export const SFDC_CONTACT_FIELDS = 'Contact'
export const SFDC_LEAD_FIELDS = 'Lead'

export const FETCH_SFDC_LEAD_ROUTING_SETTINGS_SUCCESS = 'FETCH_SFDC_LEAD_ROUTING_SETTINGS_SUCCESS'
export const FETCH_SFDC_LEAD_ROUTING_SETTINGS_ERROR = 'FETCH_SFDC_LEAD_ROUTING_SETTINGS_ERROR'

export const FETCH_SALESFORCE_ENRICHMENT = 'FETCH_SALESFORCE_ENRICHMENT'
export const FETCH_SALESFORCE_ENRICHMENT_STARTED = 'FETCH_SALESFORCE_ENRICHMENT_STARTED'
export const FETCH_SALESFORCE_ENRICHMENT_SUCCESS = 'FETCH_SALESFORCE_ENRICHMENT_SUCCESS'
export const FETCH_SALESFORCE_ENRICHMENT_FAILED = 'FETCH_SALESFORCE_ENRICHMENT_FAILED'

export const FETCH_SFDC_ENRICHMENT_FIELDS_SUCCESS = 'FETCH_SFDC_ENRICHMENT_FIELDS_SUCCESS'
export const FETCH_SFDC_ENRICHMENT_FIELDS_ERROR = 'FETCH_SFDC_ENRICHMENT_FIELDS_ERROR'
export const PATCH_SFDC_ENRICHMENT_FIELDS_SUCCESS = 'PATCH_SFDC_ENRICHMENT_FIELDS_SUCCESS'
export const PATCH_SFDC_ENRICHMENT_FIELDS_ERROR = 'PATCH_SFDC_ENRICHMENT_FIELDS_ERROR'



// WEBPACK FOOTER //
// ./src/scripts/app/modules/sfdc/constants.js